<template>
  <div class="edit-product">
    <div class="breadcrumb" style="background: #fff">电子卡券</div>
    <div class="third-title"><span>基本信息</span></div>
    <div class="order-detail-basic" style="padding-top: 0">
      <div id="qrCodeDiv"></div>
      <el-form :model="showDate" label-width="170px" ref="formRef">
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品名称:" prop="spuName"> {{ showDate.spuName }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格:" prop="spuDesc"> {{ showDate.skuName }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开卡总数:" prop="openCarNum"> {{ showDate.quantity }} </el-form-item>
          </el-col>
          <el-col :span="12" v-if="codeType !== 'free'">
            <el-form-item label="开卡总价:" prop="openCarPrice"> {{ showDate.amount }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期至:" prop="endTime"> {{ showDate.dateExpired }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="未下载:" prop="noDownload">
              <span>{{ countUnDownloaded }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="已下载:" prop="yepDownload"> {{ showDate.codeCount.countDownloaded }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="已使用:" prop="used"> {{ showDate.codeCount.countUsed }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="已删除:" prop="deleted"> {{ showDate.codeCount.countDeleted }} </el-form-item>
          </el-col>
        </el-row>
        <el-row>
        </el-row>
        <el-row>
        </el-row>
        <el-row>
        </el-row>
      </el-form>
    </div>
    <div class="third-title"><span>基本信息</span></div>
    <div class="order-detail-basic" style="padding:30px">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="item in tabsList" :key="item.value"
          :label="`${item.label}(${item.value == 3 ? showDate.codeCount.countDeleted : item.value == 2 ? showDate.codeCount.countUsed : item.value == 1 ? showDate.codeCount.countDownloaded : countUnDownloaded})`"
          :name="item.value + ''">
          <div class="couponList">
            <div class="couponItem" v-for='(item, index) in showDate.promoCodes' :key="index" style="width:177px;" @mouseenter="showDialog(index)" @mouseleave="hideDialog(index)">
              <div class="all-tool">
                <div style="width:177px;height:305px;" class="course-container" :id="`myImage${item.promoCodeId}`">
                  <div style="top:13px;right: 10px;font-size: 12px;transform: scale(0.6);" class="code">{{ item.ordinal }}</div>
                  <div class="course" :class="{ 'delete': activeName == 3 }">
                    <img style="width:177px;height:305px;" :src="showDate.imgurl" crossorigin="anonymous" />
                  </div>
                  <div style="bottom:20px;left:9px;margin-left:10px" class="code">
                    <div :id="`code${item.promoCodeId}`" :ref="`qrCodeDiv${item.promoCodeId}`" v-if="qrCodeList[`code${item.promoCodeId}`]"></div>
                    <!-- <div id="qrCode" :ref="`qrCodeDiv${item.promoCodeId}`"></div> -->
                    <img style="width:35px;height:35px;" :src="qrCode" crossorigin="anonymous" v-else />
                  </div>
                </div>
              </div>
              <div class="coupon-item-foot" v-if="activeName != 0">{{ item.promoCodeId }}-{{ item.code }}</div>
              <!--操作蒙层 codeType !== 'free' &&!item.hasDownloaded &&-->
              <div class="handleDialog" v-if="!checked && ishow && current == index && !item.countUsed && item.promoCodeStatus !== 'DELETED'">
                <!-- <i class="el-icon-delete deleteIcon" @click="deletedImage(item)"></i> -->
                <img :src="deleteIcon" class="deleteIcon" @click="deletedImage(item)" />
                <!-- <i class="el-icon-download deleteIcon" @click="saveImage(item)"></i> -->
              </div>
              <!-- <div class="handleDialog" v-if="checked">
              </div> -->
              <a id="link"></a>
              <div>
              </div>
            </div>
          </div>
          <div class='footer-button' v-if="(activeName == 0 || activeName == 1) && showDate.promoCodes.length > 0">
            <!-- <el-checkbox v-model="checked">全选</el-checkbox> -->
            <!-- <el-button v-if="checked" style='float:right' @click="saveAllImage()">下载</el-button> -->
            <!-- v-if="codeType !== 'free'" -->
            <el-button type="primary" @click="deletedImageAll(activeName)">全部刪除</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import coverImg from '@/assets/images/coverImg.jpg'
import cord from '@/assets/images/cord.jpg'
import deleteIcon from '@/assets/images/delete.png'
import html2canvas from 'html2canvas'
import { getDetailByPromoId, markDownloaded, delBatchPromo } from '@/api/epay'
export default {
  name: 'detail',
  data () {
    return {
      deleteIcon: deleteIcon,
      checked: false,
      coverImg: coverImg,
      qrCode: cord,
      qrCodeList: {},
      showDate: {
        store: {},
        sku: {},
        codeCount: {},
        promoCodes: []
      },
      tabsList: [{
        label: '未下载',
        value: 0
      },
      {
        label: '已下载',
        value: 1
      },
      {
        label: '已使用',
        value: 2
      }, {
        label: '已删除',
        value: 3
      }],
      ishow: false,
      ishowAll: true,
      current: 0,
      keyVal: 0,
      promoCodes: {
        undownloadList: [],
        downloadList: [],
        removeList: [],
        usedList: []
      },
      downloadDetail: {}, // 下载的内容
      list: [],
      countUnDownloaded: 0// 未下载数量
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  async created (val) {
    this.codeType = this.$route.query.code
    this.orderId = this.$route.query.id
    await this.getDetailById()
  },
  methods: {
    // 获取详情
    async getDetailById () {
      this.promoCodes.usedList = []
      this.promoCodes.downloadList = []
      this.promoCodes.removeList = []
      this.promoCodes.undownloadList = []
      this.ishowAll = false
      await getDetailByPromoId(this.orderId).then(res => {
        if (res.data.success) {
          let dat = res.data.data
          if (dat.promoType === 'SPU') {
            this.showDate = {
              ...dat,
              spuName: dat.name,
              skuName: ''
            }
          } else {
            this.showDate = {
              ...dat,
              skuName: dat.sku.skuName,
              spuName: dat.sku.spuName
            }
          }
          this.countUnDownloaded = this.showDate.quantity - this.showDate.codeCount.countDownloaded - this.showDate.codeCount.countDeleted - this.showDate.codeCount.countUsed
          // const temp = res.data.data.promoCodes.map(res => {
          //   return {
          //     ...res,
          //     ordinal: this.PrefixZero(res.ordinal + 1, 3)
          //   }
          // })
          const temp = res.data.data.promoCodes
          for (let i = 0; i < temp.length; i++) {
            if (temp[i].countUsed) {
              this.promoCodes.usedList.push(temp[i])
            } else {
              if (temp[i].hasDownloaded === true && temp[i].promoCodeStatus !== 'DELETED') { // 已下载
                this.promoCodes.downloadList.push(temp[i])
              } else if (temp[i].promoCodeStatus === 'DELETED') { // 已删除
                this.promoCodes.removeList.push(temp[i])
              } else {
                this.promoCodes.undownloadList.push(temp[i])
              }
            }
          }
          this.showDate.promoCodes = this.activeName == 3 ? this.promoCodes.removeList : this.activeName == 2 ? this.promoCodes.usedList : this.activeName == 1 ? this.promoCodes.downloadList : this.promoCodes.undownloadList
          // this.showDate.promoCodes = this.promoCodes.undownloadList
        }
      })
    },
    // 补齐三位数
    PrefixZero (num, n) {
      return (Array(n).join(0) + num).slice(-n)
    },
    // //绘制二维码
    createQrcode (id) {
      this.qrCodeList[id] = 11111
      this.$nextTick(_ => {
        document.getElementById('qrCodeDiv').innerHTML = ''
        let code = new QRCode('qrCodeDiv', {
          text: `http://test3.kencoo.com?spuId=${this.showDate.sku.skuId}`, // 页面地址 ,如果页面需要参数传递请注意哈希模式#
          width: 100, // 二维码宽度 （不支持100%）
          height: 100, // 二维码高度 （不支持100%）
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.Q
        })
      })
    },
    // 显示操作项
    showDialog (index) {
      this.ishow = true
      this.current = index
    },
    // 隐藏蒙层
    hideDialog (index) {
      this.ishow = false
      this.current = null
    },
    // 下载
    async saveImage (item) {
      this.ishow = false
      // 获取dom，这里合成图片是这个dom内的一切元素都会一起合成一个图片下载下来，包含里面的文字和图片，所以可以自行调整这个dom内的内容，包括文字和图片样式等，相当于就是把这个div的内容截图下来了
      // let dom = document.getElementById('myImage')
      await this.createQrcode(`code${item.promoCodeId}`)
      let opts = {
        allowTaint: true,
        logging: false,
        backgroundColor: 'transparent',
        useCORS: true,
        scale: 6,
        dpi: 300,
        canvas: document.getElementById('myCanvas')
      }

      // 调用方法下载
      html2canvas(document.getElementById(`myImage${item.promoCodeId}`), opts).then((canvas) => {
        let posterImg = canvas.toDataURL('image/jpeg', 1.0)// 转base64
        let a = document.createElement('a')
        let event = new MouseEvent('click')
        a.download = 'photo' + item.ordinal
        a.href = posterImg
        a.dispatchEvent(event)
        let data = {
          orderId: item.promoId,
          promoCodeIds: [item.promoCodeId]
        }
        // markDownloaded(data).then((res) => {
        //   console.log('res', res)
        // })
      })
    },
    // 下载全部
    saveAllImage () {
      this.showDate.promoCodes.forEach(element => {
        this.saveImage(element)
      })
    },
    // 切换tabs
    handleClick (tab, event) {
      this.showDate.promoCodes = tab.name == 3 ? this.promoCodes.removeList : tab.name == 2 ? this.promoCodes.usedList : tab.name == 1 ? this.promoCodes.downloadList : this.promoCodes.undownloadList
    },
    // 删除操作
    deletedImage (item) {
      this.$alert('是否确定删除此张电子卡券?', '操作确认', {
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        iconClass: 'el-icon-warning-outline'
      }).then(async () => {
        let data = {
          orderId: item.promoId,
          promoCodeIds: [item.promoCodeId]
        }
        let res = await delBatchPromo(data)
        if (res.data.success) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        }
        this.getDetailById()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 刪除全部
    deletedImageAll (key) {
      let promoCodeIds = []
      if (key == 0) {
        promoCodeIds = this.promoCodes.undownloadList.map(res => {
          return res.promoCodeId
        })
      } else {
        promoCodeIds = this.promoCodes.downloadList.map(res => {
          return res.promoCodeId
        })
      }
      console.log('key', key, this.countUnDownloaded)
      this.$confirm(`是否确定删除${key == 0 ? this.countUnDownloaded : this.promoCodes.downloadList.length}张电子卡券?`, '操作确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let data = {
          orderId: this.orderId,
          promoCodeIds: promoCodeIds
        }
        let res = await delBatchPromo(data)
        if (res.data.success) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getDetailById()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.couponList {
  display: flex;
  flex-wrap: wrap;

  .couponItem {
    margin: 10px 5px;
    position: relative;

    .all-tool {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: center;
      background: #fff;
      box-sizing: border-box;

      .course-container {
        height: 400px;
        width: 300px;
        position: relative;
      }

      .course {
        z-index: 1;
        position: absolute;
      }

      .delete {

        // 将图片置灰
        img {
          -webkit-filter: grayscale(1);
          /* Webkit */

          filter: gray;
          /* IE6-9 */

          filter: grayscale(1);
          /* W3C */

        }
      }

      .code {
        z-index: 2;
        position: absolute;
      }
    }

    .coupon-item-foot {
      width: 100%;
      text-align: center;
    }

    .handleDialog {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      background: rgba(0, 0, 0, 0.6);
      width: 100%;
      height: 100%;
      border-radius: 4px;

      .deleteIcon {
        width: 30px;
        height: 30px;
        margin-left: 73px;
        margin-top: 137px;
        background: rgb(247, 242, 242);
        color: rgb(133, 132, 132);
        font-size: 28px;
      }
    }

    .btn-all {
      text-align: center;
      margin: 30px auto 0;
    }
  }
}

.footer-button {
  width: 60%;
}
</style>

<style>
.el-message-box__status {
  color: #E6A23C !important;
}
</style>
